<div class="backoffice-coworkings-container">
  <div class="filter-section">
    <mat-form-field>
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
  </div>
  <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="business_group">
      <th mat-header-cell *matHeaderCellDef>Grupo</th>
      <td mat-cell *matCellDef="let element">{{ element.business_group }}</td>
    </ng-container>
    <ng-container matColumnDef="business_name">
      <th mat-header-cell *matHeaderCellDef>Nombre grupo</th>
      <td mat-cell *matCellDef="let element">{{ element.business_name }}</td>
    </ng-container>
    <ng-container matColumnDef="company_name">
      <th mat-header-cell *matHeaderCellDef>Nombre coworking</th>
      <td mat-cell *matCellDef="let element">{{ element.company_name }}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>DescripciÃ³n</th>
      <td mat-cell *matCellDef="let element">{{ element.description }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    <ng-container matColumnDef="fiscal_address">
      <th mat-header-cell *matHeaderCellDef>DirecciÃ³n</th>
      <td mat-cell *matCellDef="let element">{{ element.fiscal_address }}</td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>TelÃ©fono</th>
      <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
    </ng-container>
    <ng-container matColumnDef="tax_id">
      <th mat-header-cell *matHeaderCellDef>CIF</th>
      <td mat-cell *matCellDef="let element">{{ element.tax_id }}</td>
    </ng-container>
    <ng-container matColumnDef="web">
      <th mat-header-cell *matHeaderCellDef>Web</th>
      <td mat-cell *matCellDef="let element">{{ element.web }}</td>
    </ng-container>
    <ng-container matColumnDef="state_id">
      <th mat-header-cell *matHeaderCellDef>Estado</th>
      <td mat-cell *matCellDef="let element">
        <mat-select
          [(ngModel)]="element.state_id"
          name="state_id"
          (selectionChange)="changeStatus($event, element.id)"
        >
          <mat-option *ngFor="let state of coworkingStates" [value]="state.id">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <div class="actions">
          <div (click)="editCoworking(element)">
            <img [src]="getEditIcon" alt="" />
          </div>
          <div (click)="deleteCoworking(element)">
            <img [src]="getDeleteIcon" alt="" />
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [length]="resultsLength" [pageSize]="20"></mat-paginator>
</div>
